import lodash from "lodash";
import * as cartSettingsActionTypes from "../actions/types/cartSettingsActionType";

const initialState = {
	settings: [],
	error: null
};

export default function cartSettingsReducer(state = initialState, action) {
	let newState = {};

	switch (action.type) {
		// GetCart
		case cartSettingsActionTypes.FETCH_SETTINGS_REQUEST:
			newState = Object.assign({}, state, {
				// settings: []
			});
			return newState;

		case cartSettingsActionTypes.FETCH_SETTINGS_SUCCESS:
			newState = Object.assign({}, state, {
				settings: lodash.merge({}, state.settings, action.response)
			});
			return newState;

		case cartSettingsActionTypes.FETCH_SETTINGS_FAILURE:
			newState = Object.assign({}, state, {
				// settings: [],
				error: action.error
			});
			return newState;

		default:
			// ALWAYS have a default case in a reducer
			return state;
	}
}
